import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { Loadable } from '../base/components/Lodable'

const RegistroApp = Loadable(lazy(() => import('./view/RegistroCredito')))
const GestionApp = Loadable(lazy(() => import('./view/GestionVentaCredito')))
const GestionFacturasApp = Loadable(lazy(() => import('./view/GestionFacturasCredito')))
const GestionCuotaApp = Loadable(lazy(() => import('./view/PagarCuota')))
const PagarCuotaApp = Loadable(lazy(() => import('./view/PagarCuotaMovimiento')))

/**
 * Mapa de rutas
 */
export const ventaCreditoRoutesMap = {
  registro: {
    path: '/venta-credito/registro',
    name: 'Registrar Venta Crédito',
  },
  gestionVenta: {
    path: '/venta-credito/gestion',
    name: 'Gestion de ventas Crédito',
  },
  gestionFactura: {
    path: '/venta-credito/gestion-factura',
    name: 'Gestion de facturas Crédito',
  },
  gestionCuotas: {
    path: '/venta-credito/pagar-cuota',
    name: 'Pagar Cuota Crédito',
  },
  pagarCuota: {
    path: '/venta-credito/pagar-cuota-movimiento/:id',
    name: 'Pagar Cuota Crédito Movimiento',
    actionSecure: 'pagar_cuota',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const ventaCreditoRoutes = [
  {
    path: ventaCreditoRoutesMap.registro.path,
    element: <RegistroApp />,
    auth: authRoles.admin,
  },
  {
    path: ventaCreditoRoutesMap.gestionVenta.path,
    element: <GestionApp />,
    auth: authRoles.admin,
  },
  {
    path: ventaCreditoRoutesMap.gestionFactura.path,
    element: <GestionFacturasApp />,
    auth: authRoles.admin,
  },
  {
    path: ventaCreditoRoutesMap.gestionCuotas.path,
    element: <GestionCuotaApp />,
    auth: authRoles.admin,
  },
  {
    path: ventaCreditoRoutesMap.pagarCuota.path,
    element: <PagarCuotaApp />,
    auth: authRoles.admin,
  },
  // {
  //   path: ventaRoutesMap.gestionVenta.path,
  //   element: <GestionVentaApp />,
  //   auth: authRoles.admin,
  // },
  // {
  //   path: ventaRoutesMap.gestionFactura.path,
  //   element: <GestionFacturaApp />,
  //   auth: authRoles.admin,
  // },
]

export default ventaCreditoRoutes
